import React, { useState } from "react";
import Time from "./Time";

export default function TimeWrapper({ time }) {
  return (
    <div className="time-wrapper">
      <Time label={"Days"} time={time.days} />
      <Time label={"Hours"} time={time.hours} />
      <Time label={"Minutes"} time={time.minute} />
      <Time label={"Seconds"} time={time.second} />
    </div>
  );
}
